import { hashService } from './index.js'
import axios from 'axios'
import Cookie from 'js-cookie'
import jwt_decode from "jwt-decode"
import Token from "../models/Token";

const ACCESS_TOKEN_KEY = 'accessToken'
const REFRESH_TOKEN_KEY = 'refreshToken'

export default class AuthService {
    constructor() {
        axios.defaults.baseURL = process.env.VUE_APP_AUTH_API_BASE_URL
    }

    login (data) {
        data.hash = hashService.getHashFromCookies()
        console.log("axios.defaults.baseURL: " + axios.defaults.baseURL)

        return axios.post('/login', data)
            .then(response => {
                hashService.saveHashToCookies(response.data.hash)
                this.saveToken(response.data)
                this.redirect()

                return Promise.resolve(response)
            })
            .catch(error => {
                this.removeToken()

                return Promise.reject(error.response)
        })
    }

    redirect () {
        const redirectUrl = this.getRefUrl()
        window.location.replace(redirectUrl)
    }

    getRedirectUrl () {
        const url = new URL(window.location.href)
        const param = url.searchParams.get('r')

        if (!param) return process.env.VUE_APP_BASE_HOST_URL

        const redirectUrl = new URL(process.env.VUE_APP_BASE_HOST_URL)
        redirectUrl.hostname = `${param}.${redirectUrl.hostname}`
        
        if (url.hash) redirectUrl.pathname = `/${url.hash.split('#')[1]}`

        return redirectUrl
    }

    getRefUrl () {
        const url = new URL(window.location.href)
        const refUrl = url.searchParams.get('ref')

        if (!refUrl) {
            return this.getRedirectUrl()
        }

        return refUrl
    }

    loggedIn () {
        if (!this.tokenExists()) {
            return false
        }

        return true
    }

    /**
     * @returns {Object}
     */
    getToken() {
        const env = process.env.VUE_APP_ENV || 'prod'; // prod как запасной вариант
        const accessTokenKey = `${ACCESS_TOKEN_KEY}_${env}`;
        const refreshTokenKey = `${REFRESH_TOKEN_KEY}_${env}`;

        const accessToken = Cookie.get(accessTokenKey);
        const refreshToken = Cookie.get(refreshTokenKey);

        return new Token(accessToken, refreshToken)
    }

    /**
     * @param {Object} token
     */
    saveToken(token) {
        const domain = this.getDomain();
        const env = process.env.VUE_APP_ENV || 'prod';

        const jwtAccess = jwt_decode(token.accessToken);
        const jwtRefresh = jwt_decode(token.refreshToken);

        const accessTokenKey = `${ACCESS_TOKEN_KEY}_${env}`;
        const refreshTokenKey = `${REFRESH_TOKEN_KEY}_${env}`;

        Cookie.set(accessTokenKey, token.accessToken, {
            domain: domain,
            expires: new Date(jwtAccess.exp * 1000)
        });
        Cookie.set(refreshTokenKey, token.refreshToken, {
            domain: domain,
            expires: new Date(jwtRefresh.exp * 1000)
        });
    }

    removeToken() {
        const domain = this.getDomain();
        const env = process.env.VUE_APP_ENV || 'prod';

        const accessTokenKey = `${ACCESS_TOKEN_KEY}_${env}`;
        const refreshTokenKey = `${REFRESH_TOKEN_KEY}_${env}`;

        Cookie.remove(accessTokenKey, { domain: domain });
        Cookie.remove(refreshTokenKey, { domain: domain });
    }

    tokenExists () {
        const token = this.getToken()
    
        return token.accessToken !== undefined && token.refreshToken !== undefined
    }

    getDomain () {
        return window.location.hostname === 'localhost' ? window.location.hostname : process.env.VUE_APP_COOKIE_DOMAIN
    }
}
